import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var TimeInterval;
(function (TimeInterval) {
    function appliesToDay(day, interval) {
        return (interval.action_register & (1 << day)) != 0;
    }
    TimeInterval.appliesToDay = appliesToDay;
    function setDay(day, interval) {
        return { ...interval, action_register: interval.action_register ^ (1 << day) };
    }
    TimeInterval.setDay = setDay;
    function isEqualTimeIntervals(a, b) {
        if (a.sh !== b.sh) {
            return false;
        }
        if (a.sm !== b.sm) {
            return false;
        }
        if (a.eh !== b.eh) {
            return false;
        }
        if (a.em !== b.em) {
            return false;
        }
        return a.temperature === b.temperature;
    }
    TimeInterval.isEqualTimeIntervals = isEqualTimeIntervals;
    TimeInterval.default_object = {
        sm: 0,
        sh: 0,
        em: 0,
        eh: 0,
        temperature: 2930,
        action_register: 0,
    };
    TimeInterval.get = createAccessors(arrayGetSet('time_intervals'), TimeInterval.default_object);
})(TimeInterval || (TimeInterval = {}));
